import moment from "moment";

export const offerJsonObj = (
    values,
    selectedService,
    resourceData,
    state,
    globalState,
    serviceCode,
    serviceData,
    addOnState,
    isEdit,
    attributesData,
    serviceBarringState,
) => {
    let validityArray = {};
    let attributesArray = [];
    let grantsArray = [];
    let chargesArray = [];
    let resourceIdArray = [];
    let recurringFrequencyArray = [];
    let resourceIdArrayForCharges = [];
    let recurringFrequencyArrayForCharges = [];
    let usageRatePlanArray = [];
    let serviceCodeForOffer = "";
    let selectService = [];

    const roleName = localStorage.getItem("roleName");
    const convertAttributeValue = (value, attributeName, attributesData) => {
        const attributeConfig = attributesData.find(attr => attr.name === attributeName);
        if (!attributeConfig) {
            console.warn(`Attribute configuration not found for: ${attributeName}`);
            return value;
        }

        const { valueType } = attributeConfig;
        switch (valueType?.toLowerCase()) {
            case "string":
                return String(value);
            case "integer":
                return parseInt(value, 10);
            case "float64":
                return parseFloat(value);
            case "bool":
                if (typeof value === "boolean") return value;
                if (typeof value === "string") {
                    const lowerValue = value.toLowerCase();
                    return lowerValue === "true" || lowerValue === "yes" || lowerValue === "1";
                }
                if (typeof value === "number") {
                    return value === 1;
                }
                return Boolean(value);
            default:
                console.warn(`Unknown valueType: ${valueType} for attribute: ${attributeName}`);
                return value;
        }
    };

    serviceData?.forEach((value) => {
        if (values?.serviceName?.value === value?.serviceCode) {
            serviceCodeForOffer = values?.serviceName?.value;
            if ("provisioningAttributes" in value) {
                selectService.push(value?.provisioningAttributes);
            }
        }
    });

    let subscriptionValidityArray = {};
    const convertedStartDateTime = moment(values.offerStartsOn).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]");
    validityArray.from = convertedStartDateTime;

    if (!state) {
        const convertedEndDateTime = moment(values.offerEndsOn).endOf("day").utc().set({
            hour: 23,
            minute: 59,
            second: 59
        }).format();
        validityArray.to = convertedEndDateTime;
    }

    subscriptionValidityArray.startTimeType = values?.subscriptionStartsOn?.value;
    subscriptionValidityArray.endTimeType = values?.subscriptionEndsOn?.value;
    subscriptionValidityArray.relativeStartTimeUnit = parseInt(values?.timePeriodOptionStart?.value);
    subscriptionValidityArray.relativeStartTimeValue = parseInt(values?.timePeriodStart);
    subscriptionValidityArray.relativeEndTimeUnit = parseInt(values?.timePeriodOption?.value);
    subscriptionValidityArray.relativeEndTimeValue = parseInt(values?.timePeriod);

    let grantsMergedArray = [...values.grants, ...values.recurringGrants];
    let chargesMergedArray = [...values.charges, ...values.recurringCharges];
    let usageRatePlanMergedArray = [...values.usageRatePlan, ...values.recurringUsageRatePlan];

    const innerArray = attributesData;

    resourceData.forEach((value) => {
        grantsMergedArray.forEach((val) => {
            if (val.resourceType?.label === value.name) {
                resourceIdArray.push(value.resourceId);
            }
        });
        chargesMergedArray.forEach((val) => {
            if (val.resourceType?.label === value.name) {
                resourceIdArrayForCharges.push(value.resourceId);
            }
        });
    });

    grantsMergedArray.forEach((val) => {
        recurringFrequencyArray.push(parseInt(val?.recurringFrequency?.value));
    });
    chargesMergedArray.forEach((val) => {
        recurringFrequencyArrayForCharges.push(parseInt(val?.recurringFrequency?.value));
    });

    grantsMergedArray.forEach((value, index) => {
        grantsArray.push({
            amount: value.resourceValue === "0" ? 0 : value.resourceValue,
            infinite: value?.infinite?.label === undefined ? "" : value?.infinite?.value,
            prorate: value.prorate,
            overridable: value?.override === true,
            resourceName: value.resourceType.value,
            resourceId: resourceIdArray[index],
            type: parseInt(value.type),
            recurringFrequency: recurringFrequencyArray[index],
            cycleAlignment: value?.cycleAlignment?.value,
            recurringFrequencyValue: value?.recurringFrequencyUnit,
            customValidity: {
                startTimeType: value?.validityStartsOn?.value,
                endTimeType: value?.validityEndsOn?.value,
                relativeStartTimeUnit: 0,
                relativeStartTimeValue: 0,
                relativeEndTimeUnit: value?.grantValidityEndsOn?.value,
                relativeEndTimeValue: value?.validityStartsOn?.value === 0 ? 0 : (parseInt(value?.grantValidityEndsOnTimeperiod) || 1)
            },
            ...(value?.validityStartsOn?.value === 0 && {
                valid: {
                    from: moment(value.startDateTime).format("YYYY-MM-DDTHH:mm:ss[Z]"),
                    to: moment(value.endDateTime).format("YYYY-MM-DDTHH:mm:ss[Z]")
                }
            }),
            ...(value?.rollover && {
                rollover: {
                    maxRolloverAmount: value?.rolloverModel?.rolloverAmount,
                    maxCycleRollover: value?.rolloverModel?.rolloverCycle,
                    rolloverPriotity: value?.rolloverModel?.rolloverPriority
                }
            })
        });
    });

    chargesMergedArray.forEach((value, index) => {
        chargesArray.push({
            amount: value.resourceValue === "0" ? 0 : value.resourceValue,
            infinite: value?.infinite?.label === undefined ? "" : value?.infinite?.value,
            prorate: value.prorate,
            overridable: value?.override === true,
            resourceName: value.resourceType.value,
            resourceId: resourceIdArrayForCharges[index],
            type: parseInt(value.type),
            ...(value.type == '2' && {recurringFrequency: recurringFrequencyArrayForCharges[index]}),
            ...(value.type == '2' && {cycleAlignment: value?.cycleAlignment?.value}),
            ...(value.type == '2' && {recurringFrequencyValue: value?.recurringFrequencyUnit}),
        });
    });

    usageRatePlanMergedArray.forEach((value) => {
        let balanceImpactsArray = [];

        value?.balanceImpacts?.forEach((balance) => {
            const rateTier = [];
            const pricingModels = balance?.pricingModel?.value === "volume" && Array.isArray(balance?.pricingModelNew)
                ? balance?.pricingModelNew
                : [{}];
            pricingModels.forEach((pricingModel) => {
                rateTier.push({
                    flatRate: parseFloat(balance?.flatRate),
                    id: 1,
                    maxQuantity: balance?.pricingModel?.value === "volume" ? parseFloat(pricingModel?.endingUnit) : 0,
                    minQuantity: balance?.pricingModel?.value === "volume" ? parseFloat(pricingModel?.startingUnit) : 0,
                    perUnitRate: balance?.pricingModel?.value === "volume" ? parseFloat(pricingModel?.pricePerUnit) : parseFloat(balance?.perUnitRate),
                    tierType: balance?.pricingModel.value,
                });
            });
            balanceImpactsArray.push({
                resourceName: balance?.resourceName?.value,
                uomName: balance?.uom?.value,
                type: balance?.recurringFrequency && balance?.cycleAlignment ? 2 : 1,
                cycleAlignment: balance?.cycleAlignment && value?.type == 2 ? parseInt(balance?.cycleAlignment?.value) : 0,
                recurringFrequency: balance?.recurringFrequency && value?.type == 2  ? parseInt(balance?.recurringFrequency?.value) : 0,
                recurringFrequencyValue: balance?.recurringFrequencyUnit && value?.type == 2  ? parseInt(balance?.recurringFrequencyUnit) : 0,
                chargeRule: balance?.chargeRule?.value || '',
                chargeImpact: balance?.chargeImpact?.map(impact => impact?.value),
                validity: {
                    startTimeType: balance?.validityStart?.value,
                    endTimeType: balance?.validityEnd?.value,
                    relativeEndTimeUnit: balance?.timeUnit?.value,
                    ...(balance?.validityStart?.value === 3 && { from: moment(balance?.startDateTime).format("YYYY-MM-DDTHH:mm:ss[Z]") }),
                    ...(balance?.validityStart?.value === 3 && { to: moment(balance?.endDateTime).format("YYYY-MM-DDTHH:mm:ss[Z]") }),
                    relativeEndTimeValue: balance?.timeValue ? parseInt(balance?.timeValue) : balance?.timeValue
                },
                rateTier
            });
        });

        let usageRatePlanObject = {
            eventType: value?.eventType?.value || value?.eventType,
            ...(isEdit && { id: value?.usageId }),
            priority: parseInt(value?.priority),
            uomName: value?.unitOfMeasurement?.value,
            balanceImpact: balanceImpactsArray
        };

        // Conditionally add attributeRule only if attributeBasedDetails exists and is non-empty
        if (Array.isArray(value?.attributeBasedDetails) && value.attributeBasedDetails.length > 0) {
            const attributeRuleArray = value.attributeBasedDetails
                .map((detail) => {
                    if (!detail?.ruleId || !detail?.name || !Array.isArray(detail?.conditions)) return null;
        
                    const validConditions = detail.conditions
                        .map((cond) => {
                            const attrName = cond?.attributeName?.value;
                            const operator = cond?.operator?.value || cond?.operator;
                            const rawValue = cond?.value;
                            const valueConverted = convertAttributeValue(rawValue, attrName, innerArray || []);
        
                            if (!attrName || !operator || valueConverted === undefined || valueConverted === null || valueConverted === '') {
                                return null;
                            }
        
                            return {
                                attributeName: attrName,
                                operator: operator,
                                attributeValue: valueConverted
                            };
                        })
                        .filter(Boolean);
        
                    if (validConditions.length === 0) return null;
        
                    return {
                        ruleId: detail.ruleId,
                        ruleName: detail.name,
                        ...(detail?.description && { description: detail.description }),
                        logicalOperator: detail?.logicalOperator?.value || detail?.logicalOperator,
                        conditions: validConditions
                    };
                })
                .filter(Boolean);
        
            if (attributeRuleArray.length > 0) {
                usageRatePlanObject.attributeRule = attributeRuleArray;
            }
        }
        

        usageRatePlanObject.type = value?.type ? Number(value?.type) : (value?.balanceImpacts?.[0]?.cycleAlignment && value?.balanceImpacts?.[0]?.recurringFrequency) ? 2 : 1;

        usageRatePlanArray.push(usageRatePlanObject);
    });

    const jsonObj = JSON.stringify({
        offerName: values.offerName,
        offerCode: values.offerCode,
        offerPriority: parseInt(values.offerPriority),
        description: values.description,
        validity: validityArray,
        globalScope: globalState,
        addOnOffer: addOnState,
        serviceBarringUponRenewalFailure: serviceBarringState,
        serviceCode: serviceCodeForOffer,
        aggregateVolume: Array.isArray(values.aggregateVolume)
            ? values.aggregateVolume.map(item => item.value)
            : values.aggregateVolume?.value
                ? [values.aggregateVolume.value]
                : [],
        categories: Array.isArray(values.categories)
            ? values.categories.map(item => item.value)
            : values.categories?.value
                ? [values.categories.value]
                : [],
        ...(values?.policyName?.value && { policySpecification: [values?.policyName?.value] }),
        ...(attributesArray.length !== 0 && { attributes: attributesArray }),
        ...(grantsArray.length !== 0 && { Grants: grantsArray }),
        ...(chargesArray.length !== 0 && { Charges: chargesArray }),
        ...(usageRatePlanArray.length !== 0 && { usageRatePlan: usageRatePlanArray }),
        subscriptionValidity: subscriptionValidityArray,
        ...(isEdit && {
            effectiveAt: moment(values?.effectiveAt).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]")
        })
    });

    return jsonObj;
};
